import { LogAppender } from './model/log-appender';
import { LogLevel } from './enum/log-level';

/**
 * This class configure multiple appenders with different log levels
 */
export class LoggerConfig {
  private appenders: LogAppender[] = [];

  /**
   * Creates LoggerConfig with loglevel
   *
   * @param level - Log level
   * @example
   * ```
   * const loggerConfig = new LoggerConfig(LogLevel.TRACE);
   * ```
   */
  constructor(private level: LogLevel = LogLevel.ERROR) {}

  /**
   * 
   * @param appender - Log appender
   * @example
   * ```
   * addAppender(ConsoleLogAppender);
   * ```
   */
  public addAppender(appender: LogAppender) {
    this.appenders.push(appender);
  }

  /**
   * 
   * @param level - Set the log level
   * @example
   * ```
   * setLevel(0);
   * ```
   */
  public setLevel(level: LogLevel) {
    this.level = level;
  }

  /**
   * Returns the multiple appenders in array
   * 
   * @returns Multiple appenders in Array of object
   * @example
   * ```
   * getAppenders();
   * ```
   */
  public getAppenders() {
    return this.appenders;
  }

  /**
   * Returns the log level
   * 
   * @returns Log Level
   * @example
   * ```
   * getLevel();
   * ```
   */
  public getLevel() {
    return this.level;
  }
}
